<div class="card warehouse__card">
    <ul class="nav nav-tabs warehouse__tabs" role="tablist">
        <li class="nav-item" role="presentation">
            <button class="nav-link"
                    [class.active]="activeTab === 'kpis'"
                    type="button"
                    role="tab"
                    (click)="setTab('kpis')">
                <i class="ti ti-chart-bar"></i>
                KPI's {{ currentWarehouse.name }}
            </button>
        </li>
        <li class="nav-item" role="presentation">
            <button class="nav-link"
                    [class.active]="activeTab === 'invoices'"
                    type="button"
                    role="tab"
                    (click)="setTab('invoices')">
                <i class="ti ti-file-invoice"></i>
                Listado de facturas
            </button>
        </li>
        <li class="nav-item" role="presentation">
            <button class="nav-link"
                    [class.active]="activeTab === 'receivable'"
                    type="button"
                    role="tab"
                    (click)="setTab('receivable')">
                <i class="ti ti-currency-dollar"></i>
                Cuentas por cobrar
            </button>
        </li>
    </ul>

    <div class="card-body warehouse__body" *ngIf="activeTab === 'kpis'">
        <div class="warehouse__stats">
            <div class="warehouse__stat warehouse__stat--charged">
                <div class="warehouse__stat-icon"><i class="ti ti-currency-dollar"></i></div>
                <div class="warehouse__stat-info">
                    <span class="warehouse__stat-label">Total cobrado</span>
                    <span class="warehouse__stat-value">{{ formatCurrency(kpis.charged) }}</span>
                    <span class="warehouse__stat-delta"
                          [class.is-down]="kpis.chargedDelta < 0">
                        {{ formatDelta(kpis.chargedDelta) }}
                        <span class="warehouse__stat-delta-note">vs semana anterior</span>
                    </span>
                </div>
            </div>

            <div class="warehouse__stat warehouse__stat--spent">
                <div class="warehouse__stat-icon"><i class="ti ti-receipt"></i></div>
                <div class="warehouse__stat-info">
                    <span class="warehouse__stat-label">Total gastado</span>
                    <span class="warehouse__stat-value">{{ formatCurrency(kpis.spent) }}</span>
                    <span class="warehouse__stat-delta"
                          [class.is-down]="kpis.spentDelta < 0">
                        {{ formatDelta(kpis.spentDelta) }}
                        <span class="warehouse__stat-delta-note">vs semana anterior</span>
                    </span>
                </div>
            </div>

            <div class="warehouse__stat warehouse__stat--profit">
                <div class="warehouse__stat-icon"><i class="ti ti-trending-up"></i></div>
                <div class="warehouse__stat-info">
                    <span class="warehouse__stat-label">Utilidad neta</span>
                    <span class="warehouse__stat-value">{{ formatCurrency(kpis.profit) }}</span>
                    <span class="warehouse__stat-delta"
                          [class.is-down]="kpis.profitDelta < 0">
                        {{ formatDelta(kpis.profitDelta) }}
                        <span class="warehouse__stat-delta-note">vs semana anterior</span>
                    </span>
                </div>
            </div>

            <div class="warehouse__stat warehouse__stat--margin">
                <div class="warehouse__stat-icon"><i class="ti ti-percentage"></i></div>
                <div class="warehouse__stat-info">
                    <span class="warehouse__stat-label">Margen de utilidad</span>
                    <span class="warehouse__stat-value">{{ formatPercent(kpis.margin) }}</span>
                    <span class="warehouse__stat-delta"
                          [class.is-down]="kpis.marginDelta < 0">
                        {{ formatDelta(kpis.marginDelta) }}
                        <span class="warehouse__stat-delta-note">vs semana anterior</span>
                    </span>
                </div>
            </div>
        </div>

        <div class="warehouse__grid">
            <section class="warehouse__panel warehouse__panel--supplies">
                <h5 class="warehouse__panel-title">Top insumos por gasto</h5>
                <ul class="warehouse__supplies">
                    <li class="warehouse__supply" *ngFor="let supply of topSupplies">
                        <span class="warehouse__supply-dot" [style.background]="supply.color"></span>
                        <span class="warehouse__supply-name" [title]="supply.name">{{ supply.name }}</span>
                        <span class="warehouse__supply-share">{{ formatPercent(supply.share) }}</span>
                        <span class="warehouse__supply-amount">{{ formatCurrency(supply.spent) }}</span>
                    </li>
                </ul>
            </section>

            <section class="warehouse__panel warehouse__panel--chart">
                <div class="warehouse__panel-head">
                    <div class="warehouse__legend">
                        <span class="warehouse__legend-item">
                            <span class="warehouse__legend-dot warehouse__legend-dot--charged"></span>
                            Cobrado
                        </span>
                        <span class="warehouse__legend-item">
                            <span class="warehouse__legend-dot warehouse__legend-dot--spent"></span>
                            Gastado
                        </span>
                    </div>
                    <span class="warehouse__panel-note">Mensual</span>
                </div>
                <div class="warehouse__chart">
                    <canvas #incomeChart aria-label="Ingresos contra gastos por mes" role="img"></canvas>
                </div>
            </section>
        </div>

        <section class="warehouse__panel warehouse__panel--breakdown">
            <div class="warehouse__panel-head">
                <h5 class="warehouse__panel-title mb-0">Desglose por insumo</h5>
                <div class="warehouse__breakdown-tools">
                    <label class="warehouse__month">
                        <span class="warehouse__month-label">Mostrando mes de:</span>
                        <input type="month"
                               class="form-control warehouse__month-input"
                               [(ngModel)]="selectedMonth"
                               aria-label="Mes del desglose">
                    </label>
                    <button type="button" class="btn warehouse__pdf-btn" (click)="downloadPdf()">
                        <i class="ti ti-download"></i>
                        Descargar PDF
                    </button>
                </div>
            </div>

            <div class="warehouse__table-wrap">
                <table class="warehouse__table">
                    <thead>
                        <tr>
                            <th scope="col">Insumo</th>
                            <th scope="col" class="text-end">Cobrado</th>
                            <th scope="col" class="text-end">Gastado</th>
                            <th scope="col" class="text-end">Utilidad</th>
                            <th scope="col" class="text-end">Margen</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let row of breakdown">
                            <td class="warehouse__table-name">{{ row.name }}</td>
                            <td class="text-end">{{ formatCurrency(row.charged) }}</td>
                            <td class="text-end">{{ formatCurrency(row.spent) }}</td>
                            <td class="text-end">{{ formatCurrency(profitOf(row)) }}</td>
                            <td class="text-end">
                                <span class="warehouse__margin-badge">{{ formatPercent(marginOf(row)) }}</span>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </section>
    </div>

    <div class="card-body warehouse__body" *ngIf="activeTab === 'invoices'">
        <app-invoices-panel [showStampBalance]="false" source="warehouse"></app-invoices-panel>
    </div>

    <div class="card-body warehouse__body" *ngIf="activeTab === 'receivable'">
        <app-receivable-panel source="warehouse"></app-receivable-panel>
    </div>
</div>

<ngx-spinner bdColor="rgba(0, 0, 0, 0.7)" size="medium" color="#fff" type="ball-atom">
    <div class="loader"></div>
    <p style="font-size: 20px; color: white">Espere un momento...</p>
</ngx-spinner>
